import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Components

import ConsultListsForm from "../../components/forms/ConsultListsForm/ConsultListsForm";

// Styles

import "./Styles.scss";

export default function DocumnentInfo() {
  const { state } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const clientEmail = localStorage.getItem("clientEmail");

    if (!clientEmail) {
      navigate(`/`);
    }
  }, []);

  return (
    <div className="page-wrapper">
      <div className="container">

        {/* CONSULT CLIENT NAME ON INTERNATIONAL LIST */}

        <div className="onboarding-page-get-info">
          <div className="onboarding-page-get-info-heading">
          </div>

          <ConsultListsForm state={state} />
        </div>

      </div>
    </div>
  );
}
